import { useEffect } from 'react';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('useScriptTag'); // eslint-disable-line no-unused-vars

const wrap = (tag, contents) => {
  tag = fromAnyToTrimmed(tag);
  contents = fromAnyToString(contents);

  return `
  
try {

;; // script ${tag} bgn

${contents}

;; // script ${tag} end

} catch (e) {
  console.warn(${tag},e);
}

`;
};

// noinspection JSUnusedGlobalSymbols
export const useScriptTagLink = (url) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = fromAnyToString(url);
    script.async = true;

    document.body.appendChild(script);

    return () => void document.body.removeChild(script);
  }, [url]);
};

// noinspection JSUnusedGlobalSymbols
export const useScriptTagInline = (contents) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.type = 'module';
    script.defer = true;
    script.innerHTML = wrap('useScriptTagInline()', contents);

    document.body.appendChild(script);

    return () => void document.body.removeChild(script);
  }, [contents]);
};
